import type { DwellTimeHelper } from '@atlassiansox/analytics-web-client';

import getDwellTimeHelper from './dwell-time-provider';

let dwellHelper: DwellTimeHelper | null = null;

const buildDwellEventData = (source: any) => {
	return {
		actionSubject: 'page',
		source,
	};
};

const sendDwellEvent = (eventData: any, analyticsClient: any) => {
	analyticsClient.sendTrackEvent(eventData);
};

const initialiseDwellTime = (eventSource: any, analyticsClient: any) => {
	if (eventSource) {
		const updatedEventData = buildDwellEventData(eventSource);
		dwellHelper = getDwellTimeHelper(
			(eventData: any) => sendDwellEvent(eventData, analyticsClient),
			updatedEventData,
		);

		dwellHelper.start();
	}
};

const recordNewPageForDwellTime = (eventSource: any) => {
	if (dwellHelper) {
		if (eventSource) {
			const updatedEventData = buildDwellEventData(eventSource);
			dwellHelper.newPage(updatedEventData);
		} else {
			// eslint-disable-next-line no-console
			console.error(
				'Unable to record dwell time transition - missing analytics key or source mapping for route',
			);
		}
	} else {
		// eslint-disable-next-line no-console
		console.error('Dwell time has not been initialised');
	}
};

/**
 * Initialises dwell time measurement, or records a page transition if it is already initialised.
 * Note that dwell time will only be initialised on routes that have an analytics key, which should be
 * all routes except for those that result in a redirect.
 */
const recordDwellTime = (analyticsKey: string, analyticsClient: any) => {
	const eventName = analyticsClient.mapAnalyticsKeyToEvent(analyticsKey);
	const eventSource = eventName ? `${eventName}Screen` : null;
	if (!dwellHelper) {
		initialiseDwellTime(eventSource, analyticsClient);
	} else {
		recordNewPageForDwellTime(eventSource);
	}
};

export default recordDwellTime;
